import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { CompanyComponent } from '../company/company.component';

@Component({
  selector: 'app-company-list',
  templateUrl: './company-list.component.html',
  styleUrls: ['./company-list.component.css']
})
export class CompanyListComponent implements OnInit {

  public menu_item_id = '36';
  public add_auth;
  public edit_auth;
  public del_auth;

  private dp = [];
  displayedColumns = ['company_name', 'company_name_en', 'company_email', 'company_resp', 'resp_mobile',
    'company_tel1', 'company_tel2', 'company_address', 'company_cr', 'company_tax_no', 'edit', 'del'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<CompanyComponent>;
  @ViewChild(MatSort) sort: MatSort;

  model = {
    'table_name': 'company', 'company_id': '0', 'company_name': '', 'company_name_en': '', 'company_logo': '', 'company_email': '',
    'company_resp': '', 'resp_mobile': '', 'company_tel1': '', 'company_tel2': '', 'country_id': '0', 'city_id': '0',
    'company_address': '', 'company_cr': '', 'company_tax_no': '', 'comment': ''
  };

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog) { }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);
  }

  search() {

    let condition = "";

    if (this.model['company_name'] != '')
      condition = " (`company`.`company_name` LIKE '%" + this.model['company_name'] +
        "%' OR `company`.`company_name_en` LIKE '%" + this.model['company_name'] + "%') AND ";

    let query = "SELECT `company`.*,`city`.`country_id` FROM  `company`,`city` WHERE `company`.`city_id` = `city`.`city_id` AND" + condition + "`company`.`status` =  '1'";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });

  }

  newcompanyEntry() {
    this.addDialogRef = this.dialog.open(CompanyComponent, {
      hasBackdrop: false,
      //data: this.dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['status'] == 'success')
          this.search();
        //console.log(this.acct_income);
      });
  }

  editCompany(row) {

    let dialog_data = {
      'table_name': 'company', 'company_id': row.company_id, 'company_name': row.company_name, 'company_name_en': row.company_name_en,
      'company_logo': row.company_logo, 'company_email': row.company_email, 'company_resp': row.company_resp, 'resp_mobile': row.resp_mobile,
      'company_tel1': row.company_tel1, 'company_tel2': row.company_tel2, 'country_id': row.country_id, 'city_id': row.city_id,
      'company_address': row.company_address, 'company_cr': row.company_cr, 'company_tax_no': row.company_tax_no, 'comment': row.comment
    };


    this.addDialogRef = this.dialog.open(CompanyComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        this.search();
      });
  }

  delCompany(row) {
    if (confirm("نتيجة الحذف قد تؤثر على بيانات أخرى، هل أنت متأكد من رغبتك بالاستمرار؟")) {
      let values = [{ 'table_name': this.model['table_name'], 'company_id': row.company_id }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          //console.log(data);
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(" تمت العملية بنجاح ");
            this.search();
          }
          else {
            alert(" حدث خطأ الرجاء المحاولة مرة أخرى ");
          }
        });
    }
  }
}




